









import { Vue, Component, Prop } from 'vue-property-decorator'

import { IMAGE_LAZYLOAD_CLASS, DEFAULT_USER_IMAGE } from '~/configs/images'
import { preloadImage } from '~/utils/images'

@Component
export default class BBLazyBackground extends Vue {
  @Prop({
    type: String,
    default: 'div'
  })
  tag: string

  @Prop({
    type: String
  })
  src: string

  @Prop({
    type: String,
    required: false,
    default: ''
  })
  width: string

  @Prop({
    type: String,
    required: false,
    default: ''
  })
  height: string

  @Prop({
    type: String,
    default: DEFAULT_USER_IMAGE
  })
  defaultImage: string

  loadError = false

  beforeMount () {
    this.preloadBackgroundImage()
  }

  get attributes () {
    let styles: Record<string, any> | null = null

    if (this.width || this.height) {
      const widthStr = this.width
        ? this.width + 'px'
        : 'auto'
      const heightStr = this.height
        ? this.height + 'px'
        : 'auto'

      styles = {
        backgroundSize: 'cover',
        width: widthStr,
        height: heightStr
      }
    }

    if (!this.src) {
      return {
        ...this.$attrs,
        style: {
          ...styles
        }
      }
    }

    const srcAttr = this.src.includes(',')
      ? 'data-bgset'
      : 'data-bg'

    return {
      ...this.$attrs,
      class: [
        IMAGE_LAZYLOAD_CLASS
      ],
      style: {
        ...styles
      },
      [srcAttr]: this.loadError ? this.defaultImage : this.src
    }
  }

  async preloadBackgroundImage () {
    try {
      let src = this.src

      if (this.src.includes(',')) {
        src = this.src.split(',')[0]
      }

      await preloadImage(src)
    } catch (error) {
      this.loadError = true
    }
  }
}
